/**
 * MiAI — Coming Soon JS
 * Custom cursor · Form handling · Subtle interactions
 */
(function () {
  'use strict';

  // ── Custom Cursor ──────────────────────────────────────
  const cursor     = document.querySelector('.cursor');
  const cursorRing = document.querySelector('.cursor-ring');

  if (cursor && cursorRing) {
    let mouseX = -100, mouseY = -100;
    let ringX  = -100, ringY  = -100;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.transform = `translate(${mouseX - 6}px, ${mouseY - 6}px)`;
    });

    // Ring lags behind cursor
    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      cursorRing.style.transform = `translate(${ringX - 20}px, ${ringY - 20}px)`;
      requestAnimationFrame(animateRing);
    }
    animateRing();

    // Expand ring on interactive elements
    const interactables = document.querySelectorAll('a, button, input, .cap-item');
    interactables.forEach(el => {
      el.addEventListener('mouseenter', () => cursorRing.classList.add('hovering'));
      el.addEventListener('mouseleave', () => cursorRing.classList.remove('hovering'));
    });

    // Hide on leave, show on enter
    document.addEventListener('mouseleave', () => {
      cursor.style.opacity = '0';
      cursorRing.style.opacity = '0';
    });
    document.addEventListener('mouseenter', () => {
      cursor.style.opacity = '1';
      cursorRing.style.opacity = '1';
    });
  }

  // ── Email Form ─────────────────────────────────────────
  const form    = document.getElementById('cs-form');
  const success = document.getElementById('cs-success');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = document.getElementById('cs-email');
      if (!email || !email.value.trim()) return;

      // ── SHOPIFY INTEGRATION POINT ──────────────────────
      // Replace with your Klaviyo / Mailchimp / Shopify API call:
      //
      //   fetch('/contact', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      //     body: new URLSearchParams({
      //       'contact[email]': email.value.trim(),
      //       'contact[tags]': 'miai-waitlist',
      //       form_type: 'customer'
      //     })
      //   });
      // ──────────────────────────────────────────────────

      form.style.display = 'none';
      const lbl = form.previousElementSibling;
      if (lbl) lbl.style.display = 'none';
      if (success) success.classList.add('visible');
    });
  }

})();
